import { faKey, faLockAlt, faSignOut } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withTheme } from '@emotion/react';
import PropTypes from 'prop-types';
import React from 'react';
import { connect, useDispatch, useSelector } from 'react-redux';
import { closeOptionsMenu, toggleOptionsMenu } from '../../actions/menus';
import { setChangePasswordOverlay, setSelectProject } from '../../actions/overlay';
import { menusSelector } from '../../selectors/menus';
import { MenuButton, MenuLink, MenuWrapper } from './styled';
const isLogged = props => props.accessToken;
const menuId = 'id-container-options-menu';
const OptionsMenuContainer = props => {
  const {
    optionsMenuOpened
  } = useSelector(menusSelector);
  const dispatch = useDispatch();
  const closeMenuListener = event => {
    event.stopPropagation();
    const menu = document.getElementById(menuId);
    let clickedElement = event.target;
    if (menu && clickedElement !== menu && optionsMenuOpened) {
      dispatch(closeOptionsMenu());
    }
  };
  React.useEffect(() => {
    document.addEventListener('click', closeMenuListener);
    return () => {
      document.removeEventListener('click', closeMenuListener);
    };
  }, [optionsMenuOpened]);
  return /*#__PURE__*/React.createElement(MenuWrapper, {
    id: menuId
  }, isLogged(props) ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(MenuButton, {
    onClick: props.onSetPasswordClick
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "1x",
    icon: faLockAlt,
    color: props.theme.colors.dark
  }), /*#__PURE__*/React.createElement("span", null, "Changer de mot de passe")), /*#__PURE__*/React.createElement(MenuLink, {
    to: "/logout"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "1x",
    icon: faSignOut,
    color: props.theme.colors.dark
  }), /*#__PURE__*/React.createElement("span", null, "D\xE9connexion"))) : /*#__PURE__*/React.createElement(MenuLink, {
    to: "/login"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    size: "1x",
    icon: faKey,
    color: props.theme.colors.dark
  }), /*#__PURE__*/React.createElement("span", null, "Connexion")));
};
const mapStateToProps = _ref => {
  let {
    user
  } = _ref;
  return {
    accessToken: user.accessToken
  };
};
const mapDispatchToProps = dispatch => ({
  onSetPasswordClick: event => {
    event.stopPropagation();
    return dispatch(setChangePasswordOverlay());
  },
  onSetProjectListClick: event => {
    event.stopPropagation();
    return dispatch(setSelectProject());
  },
  handleOptionsClick: event => {
    event.stopPropagation();
    return dispatch(toggleOptionsMenu());
  }
});
OptionsMenuContainer.propTypes = {
  accessToken: PropTypes.string,
  onSetPasswordClick: PropTypes.func.isRequired,
  onSetProjectListClick: PropTypes.func.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(withTheme(OptionsMenuContainer));